import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView } from 'react-native';
import { useSelector } from 'react-redux'
const AgentIcon = (props) => (
  <Icon {...props} name='person'/>
);

const AlertIcon = (props) => (
  <Icon {...props} name='unlock'/>
);

export const AgentInfo = () => {
  const agent = useSelector ( state => state.login.information)
  return (
    <Layout level='3' style={{paddingHorizontal:15, marginVertical:5, paddingTop:5, paddingBottom:20, marginHorizontal:6, borderRadius:10}} >

        <Layout level='3' style={{flexDirection:'row', justifyContent:'space-between', marginTop:5}}>

        <Layout level='3' style={{flex:2,marginRight:10}}>
          <Text category='c2' appearance='hint'> اطلاعات تکنسین</Text>
          <Input
            value= {agent.firstname + ' ' + agent.lastname}
            accessoryLeft={AgentIcon}
            disabled
            />
          </Layout>
          <Layout level='3' style={{flex:1}}>
            <Text category='c2' appearance='hint'> کد تکنسین</Text>
            <Input
              style={{textAlign:'center'}}
              value={agent.id}
              accessoryLeft={AlertIcon}
              disabled
              />
            </Layout>
          </Layout>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
